import { FaLanguage } from "react-icons/fa";
import { useLanguage } from "../../hooks/useLanguage";

/**
 * Reusable Language Toggle Button Component
 * Works for both logged-in and non-logged-in users
 */
const LanguageToggleButton = ({
  className = "cart cart-profile",
  style = {},
  showText = true
}) => {
  const { selectedLang, changeLanguage } = useLanguage();

  return (
    <button
      className={className}
      onClick={() => changeLanguage(selectedLang === "en" ? "fr" : "en")}
      style={style}
      title={selectedLang === "en" ? "Switch to French" : "Passer à l'anglais"}
    >
      <FaLanguage size={20} />
      {showText && <p>{selectedLang === "en" ? "FR" : "EN"}</p>}
    </button>
  );
};

export default LanguageToggleButton;
